import type { FrontendWidget } from '../types';
import { MagazineAuthorPageHeaderComponent } from './MagazineAuthorPageHeaderComponent';
import type {
  MagazineAuthorPageHeaderConfig,
  MagazineAuthorPageHeaderResolved,
} from './types';

/**
 * Inline, **context-backed** (30.03.05 § Classification): `resolveSync` and no
 * backend resolver — the block carries no fields and reads its entity from
 * `ctx.entities`.
 */
export const magazineAuthorPageHeaderWidget: FrontendWidget<
  MagazineAuthorPageHeaderConfig,
  MagazineAuthorPageHeaderResolved
> = {
  componentType: 'magazine.author-page-header',
  displayName: 'Magazine Author Page Header',
  ComponentA: MagazineAuthorPageHeaderComponent,
  resolveSync: () => ({}),
};
